import gsap from 'gsap';
import React, { createRef, forwardRef, useEffect, useState } from 'react';
import styled, { css } from 'styled-components';
import { mergeRefs } from '../helpers';
export const TextareaWrapper = styled.label `
  color: var(--textarea-color, ${({ theme }) => theme.style.textareaTextColor});
  background-color: var(--textarea-background, ${({ theme }) => theme.style.formElementBackgroundColor});
  display: block;
  position: relative;
  border-radius: ${({ theme }) => theme.style.textareaBorderRadius};
  font-weight: ${({ theme }) => theme.style.textareaFontWeight};
  font-size: ${({ theme }) => theme.style.textareaFontSize};
  cursor: text;
  height: calc(${({ theme }) => theme.style.textareaLineHeight} * 4);
  transition:
    background-color 0.2s,
    box-shadow 0.2s,
    color 0.2s;
  box-sizing: border-box;
  box-shadow:
    inset 0 0 0 var(--textarea-border, 1px)
      var(--textarea-border-color, ${({ theme }) => theme.style.textareaBorderColor}),
    0 0 0 var(--textarea-outline, 0px) var(--textarea-outline-color, transparent),
    ${({ theme }) => theme.style.depressedShadow};

  --textarea-placeholder-color: ${({ theme }) => theme.style.textareaPlaceholderTextColor};

  --textarea-background: ${({ theme, isHovered }) => isHovered && theme.style.textareaHoveredBackgroundColor};
  --textarea-border-color: ${({ theme, isHovered }) => isHovered && theme.style.textareaHoveredBorderColor};
  --textarea-placeholder-color: ${({ theme, isHovered, isFocussed }) => (isHovered || isFocussed) && theme.style.textareaHoveredPlaceholderTextColor};

  --textarea-background: ${({ isFocussed, hasError, theme }) => (isFocussed || hasError) && theme.background};

  --textarea-background: ${({ isFocussed, theme }) => isFocussed && theme.style.textareaFocussedBackgroundColor};
  --textarea-border: ${({ isFocussed, theme }) => isFocussed && theme.style.textareaFocussedBorder};
  --textarea-border-color: ${({ theme, isFocussed }) => isFocussed && theme.style.textareaFocussedBorderColor};
  --textarea-outline: ${({ isFocussed, theme }) => isFocussed && theme.style.textareaFocussedOutline};
  --textarea-outline-color: ${({ theme, isFocussed }) => isFocussed && theme.style.textareaFocussedOutlineColor};

  cursor: ${({ isDisabled }) => isDisabled && 'not-allowed'};
  opacity: ${({ isDisabled }) => isDisabled && 0.75};

  --textarea-color: ${({ theme, hasError }) => hasError && theme.style.textareaErrorTextColor};
  --textarea-border-color: ${({ theme, hasError }) => hasError && theme.style.textareaErrorBorderColor};
  --textarea-background: ${({ hasError, theme }) => hasError && theme.style.textareaErrorBackgroundColor};
  --textarea-outline-color: ${({ theme, hasError }) => hasError && theme.style.textareaErrorOutlineColor};
  --textarea-placeholder-color: ${({ theme, hasError }) => hasError && theme.style.textareaErrorPlaceholderTextColor};

  --textarea-line-height: ${({ theme }) => theme.style.textareaLineHeight};

  /* ${({ theme }) => theme.id !== 'default' &&
    css `
      --textarea-background: ${() => theme.secondary.blendToBackground(25)};
      --textarea-background: ${({ isHovered, isFocussed }) => isHovered && !isFocussed && theme.secondary.blendToBackground(50)};
    `} */

  ${({ size }) => size === 'small' &&
    css `
      border-radius: ${({ theme }) => theme.style.textareaSmallBorderRadius};
      font-weight: ${({ theme }) => theme.style.textareaSmallFontWeight};
      font-size: ${({ theme }) => theme.style.textareaSmallFontSize};

      --textarea-line-height: ${({ theme }) => theme.style.textareaSmallLineHeight};
    `}

  ${({ variant }) => variant === 'light' &&
    css `
      box-shadow:
        0px 1px 2px var(--textarea-shadow, rgba(38 38 44 / 10%)),
        0px 2px 6px var(--textarea-shadow-second, rgba(38 38 44 / 5%)),
        inset 0 0 0 var(--textarea-border, 1px) var(--textarea-border-color, transparent),
        0 0 0 var(--itextareanput-outline, 0px) var(--textarea-outline-color, transparent);

      --textarea-shadow: ${({ theme, isFocussed }) => isFocussed && theme.primary.blendToBackground(1000, 100)};

      --textarea-background: ${({ theme, hasError }) => !hasError && theme.background};
      --textarea-border-color: ${({ theme, isFocussed, hasError }) => hasError && !isFocussed && theme.danger.blendToBackground(1000, 150)};

      --textarea-shadow: ${({ theme, hasError }) => hasError && theme.danger.blendToBackground(1000, 100)};
      --textarea-shadow-second: ${({ hasError, isFocussed }) => (hasError || isFocussed) && css `transparent`};
    `}

  ${({ variant }) => variant === 'line' &&
    css `
      background: none;
      box-shadow: none;
      &:before {
        content: '';
        height: 2px;
        position: absolute;
        left: -50%;
        right: -50%;
        bottom: 0;
        border-radius: 1px;
        transform: scale(0.5) translateZ(0);
        background-color: var(--textarea-line, ${({ theme }) => theme.secondary.blendToBackground(400)});
        box-shadow: 0 0 0 calc(var(--textarea-outline, 0px) * 2) var(--textarea-outline-color, transparent);
        transition:
          background-color 0.2s,
          box-shadow 0.2s;

        --textarea-border-color: ${({ theme, hasError }) => hasError && theme.danger.background};
        --textarea-line: ${({ hasError, isFocussed }) => (hasError || isFocussed) && css `var(--textarea-border-color)`};
      }
    `}
`;
export const TextareaElement = styled.textarea `
  appearance: none;
  background: none;
  border: none;
  outline: none;
  padding: ${({ theme }) => theme.style.textareaPadding};
  margin: 0;
  color: inherit;
  line-height: ${({ theme }) => theme.style.textareaLineHeight};
  min-height: calc(${({ theme }) => theme.style.textareaLineHeight} * 4);
  display: block;
  position: absolute;
  box-sizing: border-box;
  left: 0;
  top: 0;
  width: 100%;
  transition-delay: 9999s;
  transition-property: background-color;
  resize: none;

  cursor: ${({ isDisabled }) => isDisabled && 'not-allowed'};

  &::placeholder {
    color: var(--textarea-placeholder-color);
    transition: color 0.2s;
  }

  ${({ size }) => size === 'small' &&
    css `
      padding: ${({ theme }) => theme.style.textareaSmallPadding};
    `}

  ${({ variant }) => variant === 'line' &&
    css `
      padding-left: 0;
      padding-right: 0;
    `}
`;
const Floating = styled.div `
  color: var(--textarea-placeholder-color);
  transition:
    color 0.2s,
    transform 0.2s,
    font-weight 0.2s;
  position: absolute;
  left: 0;
  top: 9px;
  line-height: var(--textarea-line-height);
  transform: translateY(var(--textarea-floating-y, 1px)) scale(var(--textarea-floating-s, 1)) translateZ(0);
  transform-origin: 0% 50%;

  ${({ size }) => size === 'small' &&
    css `
      top: 5px;
    `}

  ${({ isFilled, isFocussed }) => (isFilled || isFocussed) &&
    css `
      --textarea-floating-y: -20px;
      --textarea-floating-s: 0.6;

      --textarea-floating-y: ${({ size }) => size === 'small' && css `-16px`};
      --textarea-floating-s: ${({ size }) => size === 'small' && css `.55`};
    `}
`;
export const Textarea = forwardRef((props, ref) => {
    const [isHoveredState, setIsHoveredState] = useState(props.isHovered ?? false);
    const [isFocussedState, setIsFocussedState] = useState(props.isFocussed ?? false);
    const [isFilledState, setIsFilledState] = useState(props.isFilled ?? false);
    const onChange = props.onChange ??
        (() => {
            /* NOOP */
        });
    const onFocus = props.onFocus ??
        (() => {
            /* NOOP */
        });
    const onBlur = props.onBlur ??
        (() => {
            /* NOOP */
        });
    const onKeyDown = props.onKeyDown ??
        (() => {
            /* NOOP */
        });
    const textareaRef = createRef();
    const wrapperRef = createRef();
    const styleProps = {
        isHovered: props.isHovered ?? isHoveredState,
        isFocussed: props.isFocussed ?? isFocussedState,
        isFilled: props.isFilled ?? isFilledState,
        isDisabled: props.isDisabled ?? false,
        isPressed: props.isPressed ?? false,
        hasError: props.hasError ?? false,
        variant: props.variant ?? 'default',
        size: props.size ?? 'default',
    };
    const getTextareaHeight = () => {
        if (textareaRef.current) {
            textareaRef.current.style.height = 'auto';
            const height = textareaRef.current.scrollHeight;
            textareaRef.current.style.height = '100%';
            return height;
        }
        return undefined;
    };
    const setTextareaHeight = (height, duration = 0.1, callback) => {
        if (textareaRef.current && wrapperRef.current && height) {
            gsap.to(wrapperRef.current, {
                height,
                duration,
                onStart: (textarea) => {
                    textarea.style.overflow = 'hidden';
                },
                onUpdate: (textarea) => {
                    textarea.scrollTo(0, 0);
                },
                onComplete: (textarea) => {
                    textarea.style.overflow = 'auto';
                    if (callback) {
                        callback();
                    }
                },
                onStartParams: [textareaRef.current],
                onUpdateParams: [textareaRef.current],
                onCompleteParams: [textareaRef.current],
            });
        }
    };
    const handleChange = (e) => {
        setTextareaHeight(getTextareaHeight());
        onChange(e.target.value);
    };
    const handleClick = () => {
        if (props.isDisabled) {
            return;
        }
        if (props.onClick) {
            props.onClick();
        }
        setIsFocussedState(true);
    };
    const handleHoverChange = (value) => {
        if (props.onHoverChange) {
            props.onHoverChange(value);
        }
        setIsHoveredState(value);
    };
    const handleFocusChange = (value) => {
        if (props.onFocusChange) {
            props.onFocusChange(value);
        }
        setIsFocussedState(value);
    };
    const handleKeyPress = (event) => {
        if (event.key === 'Enter' && props.autoBlur) {
            textareaRef.current?.blur();
        }
    };
    useEffect(() => {
        if (props.isFocussed ?? isFocussedState) {
            textareaRef.current?.focus();
        }
        else {
            textareaRef.current?.blur();
        }
    }, [isFocussedState, props.isFocussed, textareaRef]);
    useEffect(() => {
        setTextareaHeight(getTextareaHeight());
        if (props.value) {
            setIsFilledState(props.value.length > 0);
        }
    }, [props.value, textareaRef]);
    useEffect(() => {
        setTextareaHeight(getTextareaHeight(), 0);
    }, []);
    return (React.createElement(TextareaWrapper, { style: props.style, className: props.className, onMouseEnter: () => handleHoverChange(true), onMouseMove: () => handleHoverChange(true), onMouseLeave: () => handleHoverChange(false), onClick: handleClick, ref: wrapperRef, ...styleProps },
        React.createElement(TextareaElement, { onChange: handleChange, onFocus: (e) => {
                handleFocusChange(true);
                onFocus(e);
            }, onBlur: (e) => {
                handleFocusChange(false);
                onBlur(e);
            }, onKeyDown: onKeyDown, onKeyPress: handleKeyPress, autoFocus: props.autoFocus, ref: mergeRefs([ref, textareaRef]), disabled: props.isDisabled ?? false, value: props.value, readOnly: props.readOnly ?? false, maxLength: props.maxLength, placeholder: props.variant !== 'line' ? props.placeholder : undefined, ...styleProps }),
        props.variant === 'line' && React.createElement(Floating, { ...styleProps }, props.placeholder)));
});
//# sourceMappingURL=Textarea.js.map